<template>
  <ExamAnalysis @goRepeat="goRepeat" reportType="special">
    <template v-slot:bread>
      <div class="bread">
        <ExamIndexBread></ExamIndexBread>
        <span class="slash">/</span>
        <router-link :to="{ name: 'ExamPoint' }">专项练习</router-link>
        <span class="slash">/</span>
        <span>{{ specialName }}</span>
        <span class="slash">/</span>
        <span class="current">题目解析</span>
      </div>
    </template>
  </ExamAnalysis>
</template>
<script>
import ExamAnalysis from "./components/ExamAnalysis";
import ExamIndexBread from "./components/ExamIndexBread.vue";

export default {
  name: "ExamSpecialAnalysis",
  components: {
    ExamAnalysis,
    ExamIndexBread,
  },
  data() {
    return {
      specialId: this.$route.query.specialId,
      specialName: this.$route.query.specialName,
    };
  },
  methods: {
    async goRepeat() {
      let data = await this.$http.post("/api/app/practice/report", {
        type: 5,
        practise_id: this.specialId,
        report_id: this.$route.query.id,
      });
      if (data.length === 0) {
        this.$info("当前没有题目可以练习");
        return;
      }
      this.$router.push({
        name: "ExamSpecialDo",
        query: {
          id: data,
          specialName: this.specialName,
          specialId: this.specialId,
        },
      });
    },
  },
};
</script>
